import React, { useMemo } from 'react';
import { Icon, Switch, Tooltip } from 'antd';
import DepositTTL from '~pages/dashboard/properties/deposit-and-fees/deposit-ttl';

function DepositLocaleCard({
  locale,
  t,
  property,
  showBookNowModal,
  onClickEnableBookNow,
  enableBookNowLoading,
  isUserHaveUpgradePermission,
  enableBookNow,
}) {
  const depositStatus = useMemo(() => {
    const currentLocaleValidDeposit =
      property?.paymentDepositRules?.edges?.filter(rule =>
        locale === 'CN' ? rule.node.effectiveCn : rule.node.effectiveRow,
      ) || [];
    return {
      isOnlyPercentageDeposit: !currentLocaleValidDeposit.some(
        rule => rule.node.type !== 'DEPOSIT_PERCENTAGE',
      ),
      isCurrentLocaleHaveValidDeposit: currentLocaleValidDeposit.length,
      currentLocaleValidDeposit,
    };
  }, [property]);

  return (
    <>
      <div className="deposit-and-fees__locale-card">
        <div className="deposit-and-fees__locale-card__header">
          <Icon type="global" />
          <span>{locale}</span>
        </div>
        <div className="deposit-and-fees__locale-card__body">
          <Choose>
            <When
              condition={
                !depositStatus.isOnlyPercentageDeposit &&
                depositStatus.isCurrentLocaleHaveValidDeposit
              }
            >
              <div className="deposit-and-fees__locale-card__fee-formula">
                <div className="">
                  <span className="deposit-and-fees__locale-card__fee-formula__title">
                    <DepositTTL
                      t={t}
                      property={property}
                      locale={locale}
                      paymentDepositRules={property.paymentDepositRules}
                    />
                  </span>
                </div>
              </div>
            </When>
            <Otherwise>
              <div className="deposit-and-fees__locale-card__no-valid-fee">
                <Icon type="info-circle" theme="filled" style={{ color: '#FAAD14' }} />

                <span className="deposit-and-fees__header-text">
                  <If condition={!depositStatus.isCurrentLocaleHaveValidDeposit}>
                    {t('cms.deposit_and_fees.content_ttl.deposit.tips', { locale })}
                  </If>
                  <If
                    condition={
                      depositStatus.isCurrentLocaleHaveValidDeposit &&
                      depositStatus.isOnlyPercentageDeposit
                    }
                  >
                    {t('cms.deposit_and_fees.content_ttl.deposit_only_percentage_type.tips')}
                  </If>
                </span>
              </div>
            </Otherwise>
          </Choose>
        </div>
        <div className="deposit-and-fees__locale-card__footer">
          <span>{t('cms.deposit_and_fees.content_header.title')}</span>
          <Tooltip
            arrowPointAtCenter
            overlayClassName={
              (depositStatus.isCurrentLocaleHaveValidDeposit &&
                !depositStatus.isOnlyPercentageDeposit) ||
              showBookNowModal
                ? 'deposit-and-fees__book-now-tips--hidden'
                : ''
            }
            placement="top"
            title={t('cms.deposit_and_fees.content_header.no_valid.text')}
          >
            <Switch
              checked={enableBookNow}
              checkedChildren="On "
              unCheckedChildren="Off "
              disabled={
                !depositStatus.isCurrentLocaleHaveValidDeposit ||
                depositStatus.isOnlyPercentageDeposit ||
                !isUserHaveUpgradePermission
              }
              className="deposit-and-fees__header-switch"
              onClick={onClickEnableBookNow}
              loading={enableBookNowLoading}
            />
          </Tooltip>
        </div>
      </div>
    </>
  );
}
export default DepositLocaleCard;
